/* unplugin-vue-components disabled */import script from "./NavViews.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavViews.vue?vue&type=script&setup=true&lang=ts"

import "./NavViews.vue?vue&type=style&index=0&id=b7eabcc8&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7eabcc8"]])

export default __exports__